import { render, staticRenderFns } from "./NotPaid.vue?vue&type=template&id=6250a464"
import script from "./NotPaid.vue?vue&type=script&lang=js"
export * from "./NotPaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports